import { actionCreatorFactory } from '@core/utils/factories';
import { ModalMainTypes } from '@models/enums';
import {
  PaginatedResponse,
  ScopingBrowse,
  ScopingDetails,
  ScopingEquipmentData,
  ScopingSummaryData,
} from '@models/interfaces';
import { SectorDataState } from '@models/types';

const actionCreator = actionCreatorFactory('SCOPING');

export namespace ScopingActions {
  export const getScopingBrowseDataAction =
    actionCreator.createAsyncAction<PaginatedResponse<ScopingBrowse>>(
      'GET_SCOPING_BROWSE',
    );
  export const updateScopingBrowseDataAction = actionCreator.createAsyncAction<
    PaginatedResponse<ScopingBrowse>
  >('UPDATE_SCOPING_BROWSE');
  export const updateCurrentModalTypeAction =
    actionCreator.createAsyncAction<ModalMainTypes>(
      'UPDATE_CURRENT_MODAL_TYPE',
    );
  export const getScopingDetailsAction = actionCreator.createAsyncAction<
    Omit<ScopingDetails, 'categories' | 'RAD'>
  >('GET_SCOPING_DETAILS');
  export const updateScopingSummaryAction =
    actionCreator.createAsyncAction<ScopingSummaryData>(
      'UPDATE_SCOPING_SUMMARY',
    );
  export const updateScopingEquipmentAction =
    actionCreator.createAsyncAction<ScopingEquipmentData>(
      'UPDATE_SCOPING_EQUIPMENT',
    );
  export const updateScopingSectorsAction =
    actionCreator.createAsyncAction<SectorDataState>('UPDATE_SCOPING_SECTORS');
}
